import { useCallback, useMemo, useState } from 'react'
import { Popup } from 'components/Popup'
import { Button, BUTTON_TYPES } from 'components/Button'
import { AddAmendment } from 'features/ContractDetails/Facilities/AddAmendment/AddAmendment'
import { useContractDetailsPopup } from 'features/ContractDetails/Providers/ContractDetailsPopupProvider'
import { BTN_TXT } from 'constants/txt'
import { TPreviewDocument } from 'features/ContractDetails/ExtendContract/types'

export const AddAmendmentPopup = () => {
  const { addAmendmentPopup } = useContractDetailsPopup()

  const [amendmentDocument, setAmendmentDocument] =
    useState<TPreviewDocument | null>(null)
  const [currentFile, setCurrentFile] = useState<string | null>(null)

  const { selectedHSRow } = addAmendmentPopup.state.payload

  const editMode = !!selectedHSRow?.amendment_document

  const disableAddAmendmentButton = useMemo(
    () =>
      editMode
        ? currentFile
          ? false
          : amendmentDocument === null
        : amendmentDocument === null,
    [amendmentDocument, editMode, currentFile]
  )

  const onCancel = useCallback(() => {
    addAmendmentPopup.actions.close()
    setAmendmentDocument(null)
    setCurrentFile(null)
  }, [addAmendmentPopup, setAmendmentDocument])

  const FormActions = useMemo(
    () => (
      <>
        <Button onClick={onCancel} upperCase>
          {BTN_TXT.CANCEL}
        </Button>
        <Button
          type={BUTTON_TYPES.PRIMARY}
          form="add-amendment-form-id"
          htmlType="submit"
          upperCase
          disabled={disableAddAmendmentButton}
        >
          {editMode ? BTN_TXT.SAVE : BTN_TXT.ADD}
        </Button>
      </>
    ),
    [disableAddAmendmentButton, onCancel, editMode]
  )

  return (
    <Popup
      className="add-amendment-popup"
      {...addAmendmentPopup.state}
      title={`${editMode ? 'Edit' : 'Add'} ${selectedHSRow?.name} ${
        addAmendmentPopup.state.title
      }`}
      width={676}
      footer={FormActions}
      onCancel={onCancel}
    >
      <AddAmendment
        amendmentDocument={amendmentDocument}
        setAmendmentDocument={setAmendmentDocument}
        currentFile={currentFile}
        setCurrentFile={setCurrentFile}
      />
    </Popup>
  )
}
